module.exports = __webpack_public_path__ + "img/lang.47ddc57.svg";